<template>
    <div class="col-md-9">
        <h1 class="pages__title">Client</h1>
        <div class="pages__box">
            <div class="form">
                <div>

                    <LogoAvatarUploader
                        :label="'logo'"
                        :logo="client.logo"
                        :upload-handler="uploadImage"
                        @update-image="updateLogo"
                    />

                    <div class="form-group mb-3">
                        <label for="" class="form-label">Url</label>
                        <input
                            type="text"
                            v-model="client.url"
                            class="form-control pl-4"
                        >
                    </div>
                    <BaseButtons
                        :on-cancel="backToPreviousPage"
                        :on-save="validateForm"
                    />

                </div>
            </div>
        </div>
    </div>
</template>

<script>

import {defineComponent} from "vue";
import BaseButtons from "../../Common/BaseButtons.vue";
import FormError from "../../Common/FormError.vue";
import ModalHandler from "../../../mixins/ModalHandler";
import AdminPanelService from "../../../services/AdminPanelService";
import LogoAvatarUploader from "../../Common/ContentFields/LogoAvatarUploader.vue";

export default defineComponent({
    name: 'ClientsEditor',
    mixins: [ModalHandler],
    components: {LogoAvatarUploader, FormError, BaseButtons},
    props: {
        clientId: Number
    },
    data() {
        return {
            client: {
                logo: null,
                url: null,
            },
        }
    },
    methods: {
        updateLogo(result) {
            this.client.logo = result
        },
        async uploadImage(formData) {
            return await AdminPanelService.uploadLogo(formData)
        },
        async getClientInfo() {
            try {
                const {data: response} = await AdminPanelService.getClientInfo(this.clientId)
                this.client = response
            } catch (error) {
                console.error(error)
            }
        },
        validateForm() {
            if (this.clientId) {
                this.updateClientInfo()
            } else {
                this.createClient()
            }
        },

        async createClient() {
            try {
                await AdminPanelService.createClient(this.client)
                this.$showSuccessMessage('The information was saved')
                window.location.href = '/admin/panel/landing-clients'
            } catch (e) {
                console.error(e)
            }
        },
        async updateClientInfo() {
            try {
                await AdminPanelService.updateClientInfo(this.clientId, this.client)
                this.$showSuccessMessage('The information was updated')
                window.location.href = '/admin/panel/landing-clients'
            } catch (e) {
                console.error(e)
            }
        }
    },
    mounted() {
        if (this.clientId) {
            this.getClientInfo()
        }
    }
})
</script>


<style scoped>

</style>
